export default __webpack_public_path__ + "static/media/2152.3033d286.png";